import React from "react";
import TextField from '@material-ui/core/TextField';
import Expansion from 'components/Expansion'
import { makeStyles } from "@material-ui/core";
import Typography from "storybookComponents/Typography";
import Picker from "storybookComponents/Picker";
import { parseDateToString } from "../util";
import "./style.css"

const useStyle = makeStyles((theme) => ({
  container: {
    marginTop: 20
  },
  textField: {
    width: 250,
    height: 40,
    marginTop: 20
  },
  subtitle: {
    color: "rgba(51,51,51,0.5)",
    marginTop: 5
  },
  testForm: {
    // height: 100
  },
  heading: {
    fontSize: 20,
    color: "black",
    fontFamily: "Open Sans",
    marginLeft: -15,
    marginTop: 10
  },
  field: {
    marginTop: 20
  },
  helperText: {
    fontSize: 14,
    color: "rgb(169 167 167)",
    marginTop: 57
  }
}))

const formatTime = (date) => {
  let h = date.getHours();
  let m = date.getMinutes();
  let amPm = "AM";
  if (h > 12) {
    h = h - 12;
    amPm = "PM"
  }
  if (m < 10) m = "0" + m
  return h + ":" + m + amPm
}

export const parseDate = (d) => {
  const date = new Date(d);
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return month + "/" + day + "/" + date.getFullYear() + ", " + formatTime(date);
}

export default React.memo(({ setFieldValue, keyName, setDate, defaultValue }) => {
  // const [date, setDate] = React.useState();
  const classes = useStyle();

  const onChange = (value) => {
    if (value) {
      let date = new Date(value);
      setDate(parseDateToString(date));
      setFieldValue(keyName, date.toISOString())
    }
    else {
      setFieldValue(keyName, "")
    }

  }

  return (

    <div id="hyly-datePicker" className={classes.testForm}>
      <Picker format={true} type="datetime" icon={true} handleChange={onChange} placeholder="Select Date & Time" defaultValue={defaultValue} />
      <div className={classes.helperText}>This will send an invite via email and sms to all the residents</div>
    </div>

  )
})